import { ITranslations } from 'types/common';
import { CataloguesPagesTableTransFields } from './types';
import en from 'translations/en/cataloguesPagesTable.json';
import pl from 'translations/pl/cataloguesPagesTable.json';
import sl from 'translations/sl/cataloguesPagesTable.json';

export const cataloguesPagesTableTranslations: ITranslations<CataloguesPagesTableTransFields> = {
  name: 'cataloguesPagesTable',
  en,
  pl,
  sl,
};
